import script from "./articlelist.vue?vue&type=script&setup=true&lang=ts"
export * from "./articlelist.vue?vue&type=script&setup=true&lang=ts"

import "./articlelist.vue?vue&type=style&index=0&id=f7f5cfe8&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f5cfe8"]])

export default __exports__